import {VehicleType} from '../vehicleType';

export function toString(this: VehicleType) {
    return `Vehicle Type: ${this.name}`;
}
